import styled from "styled-components";
import { breakpoints } from "styles";

export const RatingFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  padding: 0;
`;

export const RatingFormHeading = styled.h1`
  width: 325px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.neutral["900"]};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  margin: 25px 0 0 0;
  text-align: center;
  line-height: 24px;
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
    width: 550px;
    margin: 0 auto;
    line-height: 48px;
  }
`;

export const StyledButtonContainer = styled.div`
  width: 100%;

  @media ${breakpoints.laptop} {
    width: 250px;
  }
`;

export const SkipCTA = styled.button`
  align-self: flex-end;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.brand["500"]};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  background: none;
  border: none;
  font-weight: bold;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;

  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["md"]};
    position: unset;
    align-self: unset;
    top: unset;
    right: unset;
  }
`;
